import { DossierDetailsContent, DossierDetailsHeader, DossierDetailsPanel } from "@/app/pages/dossier/dossier-details-panel";
import { Skeleton } from "@/shared/components";

export function TvvDetailsSkeleton() {
    return (
        <DossierDetailsPanel>
            <DossierDetailsHeader section="Tvv" showBackButton />
            <DossierDetailsContent className="space-y-6">
                <Skeleton className="h-8 w-32" />
                <div className="space-y-4">
                    <Skeleton className="h-24 w-full" />
                    <Skeleton className="h-24 w-full" />
                    <Skeleton className="h-24 w-full" />
                </div>
            </DossierDetailsContent>
        </DossierDetailsPanel>
    );
}
